import { createFileRoute } from '@tanstack/react-router';
import { useAdminAuthGuard } from '@/features/admin/hooks';
import { CompanyDetail } from '@/features/admin/CompanyDetail';
import { AdminShell } from '@/features/admin/components/AdminShell';
import { AdminLogoutButton } from '@/features/admin/components/AdminLogoutButton';

/**
 * Admin company-detail route — one company + its members, with the per-user
 * actions (force-logout, resend invite). Sits beside the Companies list (the
 * trailing `_` escapes the list route's layout). Bounces to /admin/login if the
 * admin cookie isn't set.
 */
export const Route = createFileRoute('/admin/companies_/$customerId')({
  component: AdminCompanyDetailPage,
});

function AdminCompanyDetailPage() {
  useAdminAuthGuard();
  const { customerId } = Route.useParams();
  return (
    <AdminShell actions={<AdminLogoutButton />}>
      <CompanyDetail customerId={Number(customerId)} />
    </AdminShell>
  );
}
